/* eslint-disable */
import registerBindShare from "../directives/bindShare";
export default function registerFixedShare($, apower) {
  registerBindShare($, apower);
  //only one counted sharing url is allowed
  apower.sharer = $.registerOnce({

    callbacks: {},

    data: {},

    // getShareCount: function (url, callback, scope) {
    //   url = url || location.href.replace(/\?.+/, '')

    //   if (this.data[url]) {
    //     callback.call(scope, this.data[url])
    //   }
    //   else if (this.callbacks[url]) {
    //     this.callbacks[url].push({handler: callback, scope: scope})
    //   }
    //   else {
    //     this.callbacks[url] = [{handler: callback, scope: scope}]

    //     let domain = apower.isOurDomain ? '' : location.origin

    //     $.ajax({
    //       type: 'GET',
    //       url: domain + '/admin-ajax?action=social_bookmark&url=' + encodeURIComponent(location.href),
    //       dataType: 'json',
    //       success: (function (body) {
    //         if (body.services) {
    //           var data = body.services
    //           delete data.twitter

    //           data.hatena = data['b.hatena.ne.jp'] || data.hatena
    //           delete data['b.hatena.ne.jp']

    //           for (var i in data) {
    //             var shareCount = Number(data[i]) || 0
    //             if (shareCount >= 1000) {
    //               shareCount = Math.ceil(shareCount / 100) / 10 + 'K'
    //             }

    //             data[i] = shareCount
    //           }

    //           this.data[url] = data

    //           for (var i = 0; i < this.callbacks[url].length; i++) {
    //             var handler = this.callbacks[url][i].handler
    //             var scope = this.callbacks[url][i].scope

    //             handler.call(scope, data)
    //           }
    //         }

    //         delete this.callbacks[url]
    //       }).bind(this)
    //     })
    //   }
    // }
  })
  $.register("fixed-share", {
    template: function () {
      var shareLinks = $.getDirective("bind-share").prototype.links;
      var hasWeixin =
        this.hasWeixin && shareLinks.weixin && shareLinks.weixin.img;

      if (apower.lang === "zh") {
        return (
          '<div class="counted-share-vertical" data-share>' +
          "<ul>" +
          (hasWeixin
            ? '<li class="share-vertical-weixin"><div></div></li>'
            : "") +
          '<li class="share-vertical-douban"><div></div></li>' +
          '<li class="share-vertical-qzone"><div></div></li>' +
          '<li class="share-vertical-weibo"><div></div></li>' +
          '<li class="share-vertical-tencent"><div></div></li>' +
          '<li class="share-vertical-youdao"><div></div></li>' +
          "</ul>" +
          '<div class="share-vertical-hidebar"></div>' +
          "</div>"
        );
      } else {
        var shareClass = apower.lang === "ja" ? "hatena" : "pinterest";

        return (
          '<div class="counted-share-vertical" data-share>' +
          "<ul>" +
          // '<li class="share-vertical-google"><div>-</div></li>' +
          '<li class="share-vertical-facebook"</li>' +
          '<li class="share-vertical-twitter"><div>{@@share}</div></li>' +
          '<li class="share-vertical-' +
          shareClass +
          '"></li>' +
          '<li class="share-vertical-linkedin"></li>' +
          "</ul>" +
          '<div class="share-vertical-hidebar"></div>' +
          "</div>"
        );
      }
    },

    target: "body",

    props: ["share-url"],

    shareURL: "",

    useShareCount: true,

    hasWeixin: false,

    init: function () {
      this.el.find(".share-vertical-hidebar").$on(
        "click",
        function (e) {
          this.el.toggleClass("collapsed");
        },
        this
      );

      // if (this.useShareCount && apower.lang !== "zh") {
      //   apower.sharer.getShareCount(
      //     this.shareURL,
      //     function (data) {
      //       for (var i in data) {
      //         var shareCount = data[i];
      //         var itemEl = this.el.find(".share-vertical-" + i + " div");

      //         if (shareCount > 0) {
      //           itemEl.text(shareCount);
      //         } else {
      //           itemEl.text("");
      //           this.el
      //             .find(".share-vertical-" + i)
      //             .css("background-position", "center");
      //         }
      //       }
      //     },
      //     this
      //   );
      // }
    },
  });
  //fixed share, exclude ios recorder and android recorder

  // $.registerOnce(function () {
  //   if (
  //     (["product", "article", "page", "activity"].includes(apower.pageType) &&
  //       apower.productId != 56 &&
  //       apower.productId != 96) ||
  //     location.pathname.includes("promotion") ||
  //     location.pathname.includes("vote")
  //   ) {
  //     $.newCom("fixed-share", null, {
  //       hasWeixin: true,
  //     });
  //   }
  // });
}
